import React from "react";

import cn from "classnames";
import { useIntl } from "react-intl";

import { SearchField } from "@mapmycustomers/ui";

import styles from "./Search.module.scss";

interface Props {
  className?: string;
  onChange?: (search: string) => void;
  value?: string;
}

const Search: React.FC<Props> = ({ className, onChange, value }) => {
  const intl = useIntl();

  // We're hiding this component temporarily because platform returns search results not in a way
  // we thought it would be. So we need to reconsider what this search does.
  // eslint-disable-next-line no-constant-condition
  if (true) {
    return null;
  }

  return (
    <SearchField
      allowClear
      className={cn(styles.container, className)}
      onChange={onChange}
      placeholder={intl.formatMessage({
        id: "dashboard.search.placeholder",
        defaultMessage: "Search...",
        description: "Placeholder of the search field on the Dashboard page",
      })}
      size="large"
      value={value}
    />
  );
};

export default Search;
